import { PresenceChannel } from "pusher-js"
import { HasId } from "../@types"
import { ChannelInstanceTemplate } from "../@types/channels.types"

export const ChatThreadPrivateChannelTemplate: ChannelInstanceTemplate<PresenceChannel, HasId> = {
  channelNameFactory: params => `Thread.${params.id}`,
  isPublic: false,
  isPresenceChannel: true,
}
